import { render, staticRenderFns } from "./Pagetitle.vue?vue&type=template&id=356b9730&scoped=true&"
import script from "./Pagetitle.vue?vue&type=script&lang=js&"
export * from "./Pagetitle.vue?vue&type=script&lang=js&"
import style0 from "./Pagetitle.scss?vue&type=style&index=0&id=356b9730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b9730",
  null
  
)

export default component.exports